import React, { Fragment } from 'react';
import './StemCard.scss';
import { connect } from "react-redux";
import SvgIcon from '../SvgIcon';
import Loader from '../Loader';
import AuthDropdown from '../AuthDropdown';
import { openAuthModal} from '../../redux/userActions';
import {addBookMarkWorkFlow, getBookMarksWorkFlow, deleteBookMarkWorkFlow } from '../../redux/stemActions';

const mapStateToProps = ({ viewport, stem, user  }) => {
  return {
    viewport,
    isLoggedIn: user.isLoggedIn,
    userId: user.profile.id,
    bookmarks: stem.bookmarks,
    isBookMarked: stem.isBookMarked,
    isBookmarking: stem.isBookmarking,
    activeLp: stem.activeLp,
    stemData: stem.stemStaticData,
  }
}

const mapDispatchToProps = {
  addBookMarkWorkFlow,
  deleteBookMarkWorkFlow,
  getBookMarksWorkFlow,
  openAuthModal,
}

const Bookmark = ({isBookMarked, size, lessonPlan, stemData, bmText,  isBookmarking, activeLp, addBookMarkWorkFlow, deleteBookMarkWorkFlow, getBookMarksWorkFlow, userId, bookmarks, isLoggedIn, openAuthModal, t, viewport, bookmarkEvent, isRtl}) => {
  
  const baseClassName = 'pb-stem-card';
  // const classes = {
  //   [baseClassName]: true,
  //   // [`${baseClassName}--rtl`]: isRtl
  // };

  let stemBM = [];
  let showBM = false;

  if(bookmarks && bookmarks.length > 0) {
    stemBM = bookmarks.map(el => el.lesson_plan && el.lesson_plan.id);
    if(stemBM.length > 0) showBM = stemBM.includes(lessonPlan.id)
  }

  const handleBookMark = () => {
    if(!showBM) {
      addBookMarkWorkFlow(userId, lessonPlan.id)
      .then(() => {
        getBookMarksWorkFlow(userId)
        bookmarkEvent()
        localStorage.setItem('sw-bookmark', 'bookmark' + Math.random());
      })
    }
    else {
      deleteBookMarkWorkFlow(userId, lessonPlan.id)
      .then(() => {
        getBookMarksWorkFlow(userId)
        localStorage.setItem('sw-bookmark', 'bookmark' + Math.random());
      })
    }
  }

  return (
    <Fragment>
      {isLoggedIn ?
        <span onClick={handleBookMark} className={`${baseClassName}__icon`}>
          {isBookmarking && activeLp === lessonPlan.id ? <Loader/> :
          <SvgIcon name={showBM || (isBookMarked && activeLp === lessonPlan.id) ? "bookmarked" : "bookmark"} title={bmText || stemData.attributes.bookmarkText} size={size ? size : viewport.medium ? "m" : "sm"}/>}</span>
        :
        <AuthDropdown
          t={t}
          baseClassName={baseClassName}
          //parentClassName={`${baseClassName}__auth-dropdown`}
          openAuthModal={openAuthModal}
          toggleEl={<span className={`${baseClassName}__icon`}><SvgIcon name={"bookmark"} title={bmText || stemData.attributes.bookmarkText} size={viewport.medium ? "m" : "sm"}/></span>}
          loginText = {t('global.please-log-in', {action: t('global.bookmark'), content_type: t('global.topic')})}
          isRtl={isRtl}
          align={viewport.medium ? 'right' : !viewport.medium && isRtl ? 'left' : 'right'}
        />}
    </Fragment>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Bookmark);


// WEBPACK FOOTER //
// ./src/components/StemCard/Bookmark.jsx